import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "https://www.gotparts.ca/wp-content/uploads/2024/12/logo.png";

export const Footer = () => (
  <footer className="mt-16 border-t border-border bg-surface">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 grid gap-8 md:grid-cols-4">
      <div>
        <div className="mb-3">
          <img src={LOGO_URL} alt="GOT PARTS" className="h-9 w-auto object-contain" />
        </div>
        <p className="text-sm text-steel-light max-w-xs">Your trusted partner for restaurant equipment replacement parts. Find and order parts in seconds.</p>
      </div>
      <div>
        <div className="mono text-xs uppercase tracking-[0.15em] text-steel-light mb-3">Catalogue</div>
        <ul className="space-y-2 text-sm text-steel">
          <li><Link to="/catalogue" className="hover:text-orange">All Products</Link></li>
          <li><Link to="/category/plumbing" className="hover:text-orange">Plumbing Parts</Link></li>
          <li><Link to="/category/oven-parts" className="hover:text-orange">Oven Parts</Link></li>
          <li><Link to="/category/coffee-machine-parts" className="hover:text-orange">Coffee Machine Parts</Link></li>
        </ul>
      </div>
      <div>
        <div className="mono text-xs uppercase tracking-[0.15em] text-steel-light mb-3">Company</div>
        <ul className="space-y-2 text-sm text-steel">
          <li><Link to="/about" className="hover:text-orange">About Us</Link></li>
          <li><Link to="/services" className="hover:text-orange">Services</Link></li>
          <li><Link to="/contact" className="hover:text-orange">Contact Us</Link></li>
        </ul>
      </div>
      <div>
        <div className="mono text-xs uppercase tracking-[0.15em] text-steel-light mb-3">Platform</div>
        <ul className="space-y-2 text-sm text-steel">
          <li><Link to="/favourites" className="hover:text-orange">Favourite Parts</Link></li>
          <li><Link to="/cart" className="hover:text-orange">Quick Reorder</Link></li>
          <li><Link to="/account" className="hover:text-orange">My Account</Link></li>
          <li><Link to="/admin/login" className="hover:text-orange">Admin Panel</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex flex-col sm:flex-row gap-2 justify-between text-xs text-steel-light">
        <span>© {new Date().getFullYear()} GOT PARTS. All rights reserved.</span>
        <span className="mono">created by: <a href="https://ruiguimaraes.dev" target="_blank" rel="noreferrer" className="text-graphite hover:text-orange font-medium">ruiguimaraes.dev</a></span>
      </div>
    </div>
  </footer>
);
